<ul class="sondermind-pagination">
  <li>
    <iris-button
      [type]="irisButtonTypes.TERTIARY"
      [disabled]="!hasPrev || disabled"
      (click)="selectPage(page - 1)">
        <mat-icon>chevron_left</mat-icon>
    </iris-button>
  </li>
  <li *ngFor="let pageNum of pageRange">
    <iris-button
      [type]="irisButtonTypes.TERTIARY"
      [disabled]="!pageNum || disabled"
      class="pagination-links"
      [ngClass]="{'selected': isSelected(pageNum)}"
      (click)="selectPage(pageNum)">
      {{ pageNum || '...' }}
    </iris-button>
  </li>
  <li>
    <iris-button
      [type]="irisButtonTypes.TERTIARY"
      [disabled]="!hasNext || disabled"
      class="pagination-nav"
      (click)="selectPage(page + 1)">
      <mat-icon>chevron_right</mat-icon>
    </iris-button>
  </li>
</ul>
